module.exports = __webpack_public_path__ + "assets/images/et-feature-a05103b5589237a100392bb4181ce9e8.png";